import { render, staticRenderFns } from "./Suspend.vue?vue&type=template&id=4ed62802&"
import script from "./Suspend.vue?vue&type=script&lang=js&"
export * from "./Suspend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports